<template>
  <div class="body-head">
    <node-label class="head-text" :node="node">
      <template v-if="articleType === 'opinion'">
        <SpeechBalloonLabel slot="speechBalloonLabel" :node="node" size="large" mainComponent="body-head__node-label" shadow></SpeechBalloonLabel>
      </template>
    </node-label>
    <div class="head-title" v-if="title">{{title}}</div>
    <div class="head-subheading" v-if="node.subheading">{{node.subheading}}</div>
  </div>
</template>
<script>
import get from 'lodash/get'
import NodeLabel from 'components/node/Label.vue'
import SpeechBalloonLabel from 'components/common/SpeechBalloonLabel'

import { getArticleType } from 'mixins/utilities'

export default {
  props: ['node'],
  components: {
    NodeLabel,
    SpeechBalloonLabel,
  },
  computed: {
    title() {
      if (get(this, 'node.default_head')) {
        return get(this, 'node.default_head')
      }
      return get(this, 'node.title', '')
    },
    articleType() {
      return getArticleType(this.node)
    },
  },
}
</script>

<style lang="scss">
  .body-head {
    font-family: $barlow;

    @include respond-to('mobile') {
      display: none;
    }
    .head-text{
      font-size: rem-calc(20);
      font-weight: bold;
      padding-bottom: rem-calc(15);
      text-transform: uppercase;
    }
    .head-title{
      font-size: rem-calc(38);
      line-height: rem-calc(44);
      margin-bottom: rem-calc(30);
      font-weight: bold;
    }
    .head-subheading{
      margin-top: rem-calc(-17);
      margin-bottom: rem-calc(40);
      font-size: rem-calc(25);
      line-height: rem-calc(33);
      color: $darker-gray;
    }
  }
</style>



// WEBPACK FOOTER //
// BodyHead.vue?def2e6dc